import * as ActionTypes from '../actions';

const emptyState = {
    isLoggedIn: false,
    token: null,
    currentUser: {
        username: '',
        id: null,
        name: '',
        email: '',
        picture: null
    }
};

const loadStoredState = () => {
    try {
        const stored = JSON.parse(sessionStorage.getItem('auth_data'));
        if (stored && stored.token) {
            return {...emptyState, isLoggedIn: true, token: stored.token, currentUser: stored.currentUser};
        }
    } catch (e) {
        // datos corruptos: se ignoran
    }
    return emptyState;
};

const initialState = loadStoredState();

const clearStoredSession = () => {
    sessionStorage.removeItem('token_security');
    sessionStorage.removeItem('auth_data');
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case ActionTypes.LOGIN_USER: {
            sessionStorage.setItem('token_security', action.data.token);
            const newState = executeLoginSuccess(state, action);
            sessionStorage.setItem('auth_data', JSON.stringify({token: newState.token, currentUser: newState.currentUser}));
            return newState;
        }

        case ActionTypes.LOGOUT_USER:
        case ActionTypes.CLOSE_SESSION:
            clearStoredSession();
            return executeLogoutSuccess(state, action);

        case ActionTypes.LOAD_USER:
            return {
                ...state,
                currentUser: action.currentUser
            };

        default:
            return {...state};
    }
};

export default reducer;

const executeLoginSuccess = (state, action) => {
    return {
        ...state,
        isLoggedIn: true,
        token: action.data.token,
        currentUser: {
            username: action.data.username,
            id: action.data.id,
            name: action.data.name,
            email: '',
            picture: null
        }
    };
}

const executeLogoutSuccess = (state, action) => {
    return {
        ...state,
        isLoggedIn: false,
        token: null,
        currentUser: {
            username: '',
            id: null,
            name: '',
            email: '',
            picture: null
        }
    };
}


